import * as React from 'react';
import { IFilter } from '../lib/http';
import { Alert, Panel, Row, Col } from 'react-bootstrap';
import { formatAmount } from '../../../data/utils/funcs';

interface IOverviewProps {
  filters: IFilter;
  onChange?: (category) => void;
}

interface IOvewviewState {
  InvOver_T_B_FoundNumber: string;
  InvOver_T_B_TotalAssets: string;
  InvOver_T_B_Grants: string;
  InvOver_T_B_Opex: string;
  InvOver_T_B_TotInvExp: string;
  InvOver_T_B_TotIncCon: string;
  InvOver_T_B_PortFoundNumber: string;
  InvOver_T_B_MdnAssets: string;
  InvOver_T_B_MdnGrant: string;
  InvOver_T_B_MdnOpEx: string;
  InvOver_T_B_MdnInvExp: string;
  InvOver_T_B_IncConPct: string;
  InvOver_T_B_PortFoundDef: string;
  filters: IFilter;
  loading: boolean;
}

export class Overview extends React.Component<IOverviewProps, IOvewviewState> {
  state: IOvewviewState = {
    InvOver_T_B_FoundNumber: '',
    InvOver_T_B_TotalAssets: '',
    InvOver_T_B_Grants: '',
    InvOver_T_B_Opex: '',
    InvOver_T_B_TotInvExp: '',
    InvOver_T_B_TotIncCon: '',
    InvOver_T_B_PortFoundNumber: '',
    InvOver_T_B_MdnAssets: '',
    InvOver_T_B_MdnGrant: '',
    InvOver_T_B_MdnOpEx: '',
    InvOver_T_B_MdnInvExp: '',
    InvOver_T_B_IncConPct: '',
    InvOver_T_B_PortFoundDef: '',
    filters: null,
    loading: false,
  };

  componentDidMount() {
    this.pullData(this.props.filters);
  }

  public round(numberToRound: number, precision: number) {
    return parseFloat((Math.round(numberToRound * 10) / 10).toFixed(precision));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel) {
      this.setState({ filters: this.props.filters }, () => {
        this.pullData(this.props.filters);
      });
    }
  }

  pullData(filters: IFilter) {
    const givTrendFilterBody = {
      action: 'getPeerGroupOverviewText',
      request: { assetLevel: filters.assetLevel, name: '', monthNumber: '', dateStart: '', dateEnd: '' },
    };

    this.setState({ loading: true });

    fetch('https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests', {
      method: 'POST',
      body: JSON.stringify(givTrendFilterBody),
    })
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        text = text.replace(/u0026/g, '&');
        text = text.replace(/\\/g, '');
        return JSON.parse(text);
      })
      .then((json) => {
        const InvOver_T_B_FoundNumber = json.InvOver_T_B_FoundNumber;
        const InvOver_T_B_TotalAssets = json.InvOver_T_B_TotalAssets;
        const InvOver_T_B_Grants = json.InvOver_T_B_Grants;
        const InvOver_T_B_Opex = json.InvOver_T_B_Opex;
        const InvOver_T_B_TotInvExp = json.InvOver_T_B_TotInvExp;
        const InvOver_T_B_TotIncCon = json.InvOver_T_B_TotIncCon;
        const InvOver_T_B_PortFoundNumber = json.InvOver_T_B_PortFoundNumber;
        const InvOver_T_B_MdnAssets = json.InvOver_T_B_MdnAssets;
        const InvOver_T_B_MdnGrant = json.InvOver_T_B_MdnGrant;
        const InvOver_T_B_MdnOpEx = json.InvOver_T_B_MdnOpEx;
        const InvOver_T_B_MdnInvExp = json.InvOver_T_B_MdnInvExp;
        const InvOver_T_B_IncConPct = json.InvOver_T_B_IncConPct;
        const InvOver_T_B_PortFoundDef = json.InvOver_T_B_PortFoundDef;

        this.setState({
          InvOver_T_B_FoundNumber,
          InvOver_T_B_TotalAssets,
          InvOver_T_B_Grants,
          InvOver_T_B_Opex,
          InvOver_T_B_TotInvExp,
          InvOver_T_B_TotIncCon,
          InvOver_T_B_PortFoundNumber,
          InvOver_T_B_MdnAssets,
          InvOver_T_B_MdnGrant,
          InvOver_T_B_MdnOpEx,
          InvOver_T_B_MdnInvExp,
          InvOver_T_B_IncConPct,
          InvOver_T_B_PortFoundDef,
          loading: false,
        });
      });
  }

  render() {
    const {
      loading,
      InvOver_T_B_FoundNumber,
      InvOver_T_B_TotalAssets,
      InvOver_T_B_Grants,
      InvOver_T_B_Opex,
      InvOver_T_B_TotInvExp,
      InvOver_T_B_TotIncCon,
      InvOver_T_B_PortFoundNumber,
      InvOver_T_B_MdnAssets,
      InvOver_T_B_MdnGrant,
      InvOver_T_B_MdnOpEx,
      InvOver_T_B_MdnInvExp,
      InvOver_T_B_IncConPct,
      InvOver_T_B_PortFoundDef,
    } = this.state;
    return (
      <Panel>
        <div className="panel-body">
          <Row>
            <Col sm={12} md={4}>
              <h4>Number of Foundations: </h4>
            </Col>
            <Col sm={12} md={8}>
              <h4 className="text-primary">
                {formatAmount(Number(InvOver_T_B_FoundNumber))}&nbsp;&nbsp;
                <small style={{ color: '#aaa' }}>{InvOver_T_B_PortFoundNumber}&nbsp;</small>
              </h4>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={4}>
              <h4>Assets: </h4>
            </Col>
            <Col sm={12} md={8}>
              <h4 className="text-primary">
                {InvOver_T_B_TotalAssets}&nbsp;&nbsp;<small style={{ color: '#aaa' }}>{InvOver_T_B_MdnAssets}&nbsp;</small>
              </h4>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={4}>
              <h4>Grants: </h4>
            </Col>
            <Col sm={12} md={8}>
              <h4 className="text-primary">
                {InvOver_T_B_Grants}&nbsp;&nbsp;<small style={{ color: '#aaa' }}>{InvOver_T_B_MdnGrant}&nbsp;</small>
              </h4>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={4}>
              <h4>Operating Expenses: </h4>
            </Col>
            <Col sm={12} md={8}>
              <h4 className="text-primary">
                {InvOver_T_B_Opex}&nbsp;&nbsp;<small style={{ color: '#aaa' }}>{InvOver_T_B_MdnOpEx}&nbsp;</small>
              </h4>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={4}>
              <h4>Investment Expenses: </h4>
            </Col>
            <Col sm={12} md={8}>
              <h4 className="text-primary">
                {InvOver_T_B_TotInvExp}&nbsp;&nbsp;<small style={{ color: '#aaa' }}>{InvOver_T_B_MdnInvExp}&nbsp;</small>
              </h4>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={4}>
              <h4>Incoming Contributions: </h4>
            </Col>
            <Col sm={12} md={8}>
              <h4 className="text-primary">
                {InvOver_T_B_TotIncCon}&nbsp;&nbsp;<small style={{ color: '#aaa' }}>{InvOver_T_B_IncConPct}&nbsp;</small>
              </h4>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <small>
                <i>{InvOver_T_B_PortFoundDef}</i>
              </small>
            </Col>
          </Row>
        </div>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/Overview/index.tsx